import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Alert } from 'react-native';
import { useAuth } from '../context/AuthContext';
import { Button, Input } from 'react-native-elements';

export default function LandingScreen() {
  const { signIn, signUp } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);

  const handleEmailAuth = async () => {
    if (!email || !password) {
      Alert.alert('Error', 'Please fill in all fields');
      return;
    }

    if (isSignUp) {
      await signUp({ email, password });
    } else {
      await signIn('email', { email, password });
    }
  };

  const handleGuestSignIn = async () => {
    await signIn('email', { 
      email: 'guest@example.com', 
      password: 'guestpassword123' 
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Sight Words Training</Text>
      
      <Input
        placeholder="Email"
        value={email}
        onChangeText={setEmail}
        autoCapitalize="none"
        keyboardType="email-address"
      />
      
      <Input
        placeholder="Password"
        value={password}
        onChangeText={setPassword}
        secureTextEntry
      />

      <View style={styles.buttonContainer}>
        <Button
          title={isSignUp ? "Sign Up" : "Sign In"}
          onPress={handleEmailAuth}
          buttonStyle={styles.button}
        />
      </View>

      <View style={styles.buttonContainer}>
        <Button
          title="Continue as Guest"
          onPress={handleGuestSignIn}
          type="outline"
          buttonStyle={styles.button}
        />
      </View>

      <TouchableOpacity onPress={() => setIsSignUp(!isSignUp)}>
        <Text style={styles.toggleText}>
          {isSignUp ? "Already have an account? Sign In" : "Don't have an account? Sign Up"}
        </Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 40,
    color: '#4CAF50',
  },
  buttonContainer: {
    marginVertical: 10,
  },
  button: {
    borderRadius: 25,
    paddingVertical: 12,
  },
  toggleText: {
    textAlign: 'center',
    color: '#4CAF50',
    marginTop: 20,
  },
  guestButton: {
    backgroundColor: '#FF9800',
    marginTop: 20,
    borderRadius: 25,
    paddingVertical: 12,
  },
}); 